﻿window.minutesSecondsMobile = function (thisDom, $this, minutes, seconds) {
    $this.css('display', 'block');
    var nonTimerText = $('span.resendsms-content').text();
    var timerText = nonTimerText.substr(0, nonTimerText.length - 1) + ' în ';

    if (parseInt(thisDom.$minutes_MS) == minutes && parseInt(thisDom.$seconds_MS) == seconds) {
        if (thisDom.$minutes_MS.toString().length < 2) {
            thisDom.$minutes_MS = "0" + thisDom.$minutes_MS;
        }
        if (thisDom.$seconds_MS.toString().length < 2) {
            thisDom.$seconds_MS = "0" + thisDom.$seconds_MS;
        }

        $('a.timer').html(timerText + thisDom.$minutes_MS + ':' + thisDom.$seconds_MS);
        if (parseInt(thisDom.$minutes_MS) != 0 && parseInt(thisDom.$seconds_MS) == 0) {
            thisDom.$minutes_MS--;
            thisDom.$seconds_MS = 59;
        } else if (parseInt(thisDom.$minutes_MS) == 0 && parseInt(thisDom.$seconds_MS) == 0) {
            $('a.timer').html(nonTimerText);
            delete thisDom.$minutes_MS;
            delete thisDom.$seconds_MS;
            clearInterval(thisDom.$timer_MS);
        } else {
            thisDom.$seconds_MS--;
        }
    } else {
        if (thisDom.$minutes_MS.toString().length < 2) {
            thisDom.$minutes_MS = "0" + thisDom.$minutes_MS;
        }
        if (thisDom.$seconds_MS.toString().length < 2) {
            thisDom.$seconds_MS = "0" + thisDom.$seconds_MS;
        }
        $('a.timer').html(timerText + thisDom.$minutes_MS + ':' + thisDom.$seconds_MS);

        thisDom.$seconds_MS--;
        if (parseInt(thisDom.$minutes_MS) != 0 && parseInt(thisDom.$seconds_MS) < 0) {
            thisDom.$minutes_MS--;
            thisDom.$seconds_MS = 59
        }
    }
    if (parseInt(thisDom.$minutes_MS) == 0 && parseInt(thisDom.$seconds_MS) == -1) {
        $('a.timer').html(nonTimerText);
        delete thisDom.$minutes_MS;
        delete thisDom.$seconds_MS;
        clearInterval(thisDom.$timer_MS);
    }
}

export default class MobileVerification {
    constructor() {
        this.dom = {
            $: $,
            $form: $('form'),
            $resendBtn: $('#smsVerifyBtn'),
            $smscode: $("#smscode"),
            $minutes_MS: 2,
            $seconds_MS: 0,
            $timer_MS: ''
        };

        this.init();
    }

    init() {
        this.resendSMS();
        this.resendSMSV2();
        this.sendNewSMSV2();
        this.verifyOTP();
        this.initToggleInputFocus();

        if ($("#smscode").length > 0) $("#smscode").focus();

        if ($('html').attr('lang') == "ro") {
            $(".new-telephone").on('click', (e) => {
                $(".phone-control, .standard-url").css('display', 'block');
            })
        }
    }

    initToggleInputFocus() {
        let $selectors = this.dom.$form.find('input, textarea').not('[type=checkbox]');

        $selectors
            .on('focus blur', this.toggleInputFocus.bind(this))
            .each((_, element) => {
                this.toggleInputFocus(element);
            });
    }

    toggleInputFocus(e) {
        if (!e) return;
        let $input = $(e.currentTarget ? e.currentTarget : e);
        let $parent = $input.parent();
        let $desiredElem = $parent.hasClass('eac-input-wrap') ? $parent.parent() : $parent;

        /** Trigger validation on autocomplete **/
        if (e.type === 'blur' && $input.prop('type') === 'email') {
            setTimeout(() => $input.trigger('focusout.validate', 200));
        }
        if ($parent.parent().hasClass('disabled')) {
            return;
        }

        $desiredElem
            .toggleClass('filled', $input.val().length > 0)
            .toggleClass('focus', document.activeElement === $input[0]);

        setTimeout(() => {
            $desiredElem.next('.input-results')
                .toggleClass('hidden', document.activeElement !== $input[0]);
        }, 200);
    }

    resendSMS() {
        $("body").on("click", ".resendsms", function (e) {
            var $this = $(this);

            let telephone = $('input[data-sc-field-name="telephone"]').val()
            if (telephone.length != 0 && $('form').valid()) {
                $(".loading-screen").show(0, () => {

                    telephone = telephone.replace('+48', '').replace(/\s+/g, '');
                    getAjaxData("/api/sitecore/MobileVerification/ResetPhone", "POST", true, { 'PhoneNumber': telephone }, function (data) {
                        if (data) {
                            data = JSON.parse(data);
                            if (data.IsValid) {
                                $('.mobile-info-message').show();
                                $('.mobile-error-message').hide();
                                $('.mobile-verifyotperror-message').hide();
                            }
                            else {
                                $('.mobile-info-message').hide();
                                $('.mobile-error-message').show();
                                $('.mobile-verifyotperror-message').hide();
                            }
                        }
                        else {
                            $('.mobile-info-message').hide();
                            $('.mobile-error-message').show();
                            $('.mobile-verifyotperror-message').hide();
                        }

                    });

                });
            }
            else if (telephone.length == 0) {
                $(".loading-screen").show(0, () => {

                    getAjaxData("/api/sitecore/MobileVerification/ResendSMS", "POST", true, null, function (data) {
                        if (data) {
                            data = JSON.parse(data);
                            if (data.IsValid) {
                                $('.mobile-info-message').show();
                                $('.mobile-error-message').hide();
                                $('.mobile-verifyotperror-message').hide();
                            }
                            else {
                                $('.mobile-info-message').hide();
                                $('.mobile-error-message').show();
                                $('.mobile-verifyotperror-message').hide();
                            }
                        }
                        else {
                            $('.mobile-info-message').hide();
                            $('.mobile-error-message').show();
                            $('.mobile-verifyotperror-message').hide();
                        }

                    });

                });
            }
            $(".loading-screen").hide();
        });
    }

    resendSMSV2() {
        $("body").on("click", ".resendsms-ro", function (e) {
            var $this = $(this);

            $(".loading-screen").show(0, () => {

                let telephone = "";
                let indMobileNumberChange = false;

                getAjaxData("/api/sitecore/MobileVerification/ResendSMSV2", "POST", true, { 'MobileNumber': telephone, 'IndMobileNumberChange': indMobileNumberChange }, function (data) {
                    if (data) {
                        data = JSON.parse(data);
                        if (data.IsValid) {
                            $('.mobile-info-message').show();
                            $('.mobile-error-message').hide();
                            $('.mobile-verifyotperror-message').hide();
                            $('.mobilenumber-required-message').hide();
                            $('.mobile-smscodeerror-message').hide();
                        }
                        else {
                            $('.mobile-info-message').hide();
                            $('.mobile-error-message').show();
                            $('.mobile-verifyotperror-message').hide();
                            $('.mobilenumber-required-message').hide();
                            $('.mobile-smscodeerror-message').hide();
                        }
                    }
                    else {
                        $('.mobile-info-message').hide();
                        $('.mobile-error-message').show();
                        $('.mobile-verifyotperror-message').hide();
                        $('.mobilenumber-required-message').hide();
                        $('.mobile-smscodeerror-message').hide();
                    }
                });

            });
            $(".loading-screen").hide();
        });
    }

    sendNewSMSV2() {
        let thisDom = this.dom;

        $("body").on("click", ".sendnewsms-ro", function (e) {
            var $this = $(this);

            $(".loading-screen").show(0, () => {
                $('.mobilenumber-required-message').hide();
                e.preventDefault();
                e.stopPropagation();

                let telephone = $('input[data-sc-field-name="telephone"]').val();
                let indMobileNumberChange = false;
                if (telephone == "") {
                    $('.mobilenumber-required-message').show();
                    $('.mobile-info-message').hide();
                    $('.mobile-error-message').hide();
                    $('.mobile-verifyotperror-message').hide();
                    $('.mobile-smscodeerror-message').hide();
                    $(".loading-screen").hide();
                    return false;
                }
                if (telephone.length != 0) {
                    switch ($('html').attr('lang')) {
                        case 'pl':
                            telephone = telephone.replace('+48', '').replace(/\s+/g, '');
                            break;
                        case 'ro':
                            telephone = telephone.replace('+40', '').replace(/\s+/g, '');
                            break;
                        default:
                        // code block
                    }
                    indMobileNumberChange = true;
                }

                getAjaxData("/api/sitecore/MobileVerification/ResendSMSV2", "POST", true, { 'MobileNumber': telephone, 'IndMobileNumberChange': indMobileNumberChange }, function (data) {
                    if (data) {
                        data = JSON.parse(data);
                        if (data.IsValid) {
                            if ($('html').attr('lang') == 'ro') {
                                thisDom.$minutes_MS = 2;
                                thisDom.$seconds_MS = 0;
                                thisDom.$timer_MS = setInterval(function () {
                                    minutesSecondsMobile(thisDom, $('a.timer'), 2, 0);
                                }, 1000);
                            }

                            $('.mobile-info-message').show();
                            $('.mobile-error-message').hide();
                            $('.mobile-verifyotperror-message').hide();
                        }
                        else {
                            $('.mobile-info-message').hide();
                            $('.mobile-error-message').show();
                            $('.mobile-verifyotperror-message').hide();
                        }
                    }
                    else {
                        $('.mobile-info-message').hide();
                        $('.mobile-error-message').show();
                        $('.mobile-verifyotperror-message').hide();
                    }
                });

            });
            $(".loading-screen").hide();
        });
    }

    verifyOTP() {
        var that = this;
        $("body").on("click", "#smsVerifyBtn", function (e) {

            $(".loading-screen").show();
            $('.mobile-smscodeerror-message').hide();
            e.preventDefault();
            e.stopPropagation();

            var smsCode = $('#smscode').val();
            if (smsCode == "") {
                $('.mobile-smscodeerror-message').show();
                $('.mobilenumber-required-message').hide();
                $('.mobile-info-message').hide();
                $('.mobile-error-message').hide();
                $('.mobile-verifyotperror-message').hide();
                $(".loading-screen").hide();
                return false;
            }
            var PhoneSmsCode = {
                "SmsCode": smsCode
            };
            var $this = $(this);
            getAjaxData("/api/sitecore/MobileVerification/VerifyOTP", "POST", true, PhoneSmsCode, function (data) {
                if (data) {
                    data = JSON.parse(data);
                    if (data.IsValid && data.Output.IsSuccess) {
                        location.reload();
                        $(".loading-screen").hide();
                    }
                    else {
                        data.IsValid = false;
                        $('#smscode').val("");
                        $('#smscode').parent().removeClass("focus filled");
                        $('.mobile-verifyotperror-message').show();
                        $('.mobile-info-message').hide();
                        $('.mobile-error-message').hide();
                        $(".loading-screen").hide();
                    }
                }
                return;
            }, function () {
                $(".loading-screen").hide();
                return;
            });
        });
    }

    //submit-verify - email - link
}

document.addEventListener('DOMContentLoaded', () => new MobileVerification());